import { isEmpty, isNumber } from 'lodash';

export function getPageListForNewClass(state) {
  return state.newClassPages || {};
}

/* eslint-enable */
export function getPagesPaginationForNewClass(state) {
  return state.newClassPagination;
}

export function getPageNumberForNewClass(state, getters) {
  if (
    !isEmpty(getters.getPagesPaginationForNewClass) &&
    Number(getters.getPagesPaginationForNewClass.page) >= 1
  ) {
    return getters.getPagesPaginationForNewClass.page;
  }

  const pageNumber = Number(getters.getRouteParams.page);

  if (!isNumber(pageNumber) || pageNumber < 1) {
    return 1;
  }

  return pageNumber;
}

export function getPageIdForNewClass(state, getters) {
  if (isEmpty(state.newClassPages)) {
    return '';
  }
  return state.newClassPages[Number(getters.getRouteParams.page) - 1].id;
}

export function getCurrentPageForNewClass(state) {
  return state.newClassCurrentPage;
}

export function getCardForNewClass(state) {
  return state.newClassCard;
}

export function getCardIdForNewClass(state) {
  return state.newClassCard.id;
}

export function getOptionsForNewClass(state, getters) {
  const currentPage = getters.getCurrentPageForNewClass;
  const options = currentPage.is_store_page
    ? currentPage.options
    : currentPage.answers;
  return options || [];
}

export function getEnteredValueForNewClass(state) {
  return state.newClassEnterdValue;
}

export function getCorrectOptionIndexForNewClass(state, getters) {
  return (
    getters.getOptionsForNewClass.findIndex(option => option.is_correct) + 1
  );
}

export function getIsOptionsBlankForNewClass(state, getters) {
  const currentPage = getters.getCurrentPageForNewClass;
  const options = currentPage.is_store_page
    ? currentPage.options
    : currentPage.answers;
  return (
    getters.currentPage && options && options.every(option => !option.content)
  );
}

export function getPreEnteredValueForNewClass(state, getters) {
  if (!getters.getRouteParams.page) {
    return '';
  }

  const pageId = getters.getCurrentPageForNewClass.id;

  return state.newClassPreEnteredValues[String(pageId)] || '';
}

export function getPreSelectedOptionForNewClass(state, getters) {
  const pageId = getters.getCurrentPageForNewClass.id;

  return state.newClassPreSelectedOption[String(pageId)] || {};
}

export function getSelectedOptionsForNewClass(state) {
  return state.newClassSelectedOptions;
}

export function getPageTypeNameForNewClass(state, getters) {
  const pageList = getters.getPageListForNewClass;
  const pageNumber = getters.getRouteParams.page;

  if (isEmpty(pageList) || pageNumber < 1) return '';

  return pageList[pageNumber - 1].page_type.name;
}

export function isInvalidEnteredValueLinesForNewClass(state, getters) {
  if (!getters.getEnteredValueForNewClass) return false;

  const numberOfLines =
    (getters.getEnteredValueForNewClass.match(/\n/g) || []).length + 1;
  if (getters.getPageTypeNameForNewClass === 'essay_type' && numberOfLines > 50) {
    return true;
  }

  if (getters.getPageTypeNameForNewClass === 'text_entry' && numberOfLines > 2) {
    return true;
  }

  return false;
}

export function getPagesResultForNewClass(state) {
  return state.newClassPagesResult;
}

export function getQuizAnswerValueForNewClass(state, getters) {
  const pageId = getters.getPageIdForNewClass;
  if (!getters.getPagesResultForNewClass[pageId]) return '';
  return getters.getPagesResultForNewClass[pageId].answerValue;
}

export function getSelectedOptionIndexForNewClass(state, getters) {
  const pageId = getters.getPageIdForNewClass;
  const cardType = getters.getRouterParams;
  const results = getPagesResultForNewClass;

  if (!getters.results[pageId]) {
    return null;
  }

  let options;

  if (cardType === 'cards') {
    options = getters.getCurrentPageForNewClass.answers;
  } else if (cardType === 'store-cards') {
    options = getters.getCurrentPageForNewClass.options;
  }

  let index;
  options.forEach((option, idx) => {
    if (option.id === results[pageId].optionId) {
      index = idx;
    }
  });

  return index;
}

export function getGradingStatusForNewClass(state) {
  return state.newClassGradingStatus;
}
